import styled from "styled-components";

export const ButtonComponent = styled.button`
  width: 100%;
  cursor: pointer;
  height: auto;
  min-height: 72px;
  display: flex;
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid #f3f4f6;
  background-color: white;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.04);
  padding: 12px 8px;
  transition: all 0.2s ease-in-out;

  svg {
    margin-right: 0;
    margin-bottom: 0;
    width: 20px;
    height: 20px;
    color: #242424;
  }

  p {
    color: #242424;
    text-align: center;
    font-size: 0.75rem;
    font-weight: 600;
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }

  :hover {
    border-color: #e5e7eb;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 0.06);

    svg {
      color: #242424;
    }
  }

  &:disabled {
    background-color: #f9fafb;
    color: #9ca3af;
    cursor: not-allowed;
    box-shadow: none;
    pointer-events: none;

    p,
    svg {
      color: #9ca3af !important;
    }
  }
`;
